import React from "react";
import * as S from "sanctuary";

import { CARD_PAYMENT_TYPES, toSentenceCase, PAYMENT_TYPES } from "@/util/common";
import Cash from "./cash";
import Card from "./card";
import Check from "./check";
import WirePayment from "./wire-payment";
import { PAYMENT_STATUSES } from "@/sanctuary/typedefs";
import { Box, Module, Text } from "@thecb/components";

export const PaymentDetailsContent = ({ payment }) => {
  const paymentType = S.fromMaybe("")(payment.type);
  const paymentStatus = S.fromEither("")(S.fromMaybe(S.Right(""))(payment.status));
  const decoratedPaymentType = toSentenceCase(paymentType.replace(/_/g, " "));
  const isCashPayment = paymentType === PAYMENT_TYPES.CASH;
  const isCardPayment = CARD_PAYMENT_TYPES.includes(paymentType);
  const isCheckPayment = paymentType === PAYMENT_TYPES.CHECK;
  const isWirePayment = paymentType === PAYMENT_TYPES.WIRE_PAYMENT;
  const isErroredPayment = paymentStatus === PAYMENT_STATUSES.ERRORED;

  if (isCashPayment) {
    return <Cash />;
  } else if (isCardPayment && !isErroredPayment) {
    return (
      <Card
        creditCard={payment.creditCard?.value}
        paymentType={decoratedPaymentType}
        specificParams={payment.specificParams.value}
      />
    );
  } else if (isCheckPayment && !isErroredPayment) {
    return (
      <Check
        paymentType={decoratedPaymentType}
        bankAccount={payment.bankAccount?.value}
        specificParams={payment.specificParams.value}
        checkImageUrlFront={payment.checkImageUrlFront.value}
        checkImageUrlBack={payment.checkImageUrlBack.value}
      />
    );
  } else if (isWirePayment && !isErroredPayment) {
    return (
      <WirePayment
        paymentType={decoratedPaymentType}
        wirePayment={payment.wirePayment?.value}
      />
    );
  } else {
    return (
      <Box padding="48px" textAlign="center">
        <Text as="p" weight="700" extraStyles="margin-bottom: 0">
          Details Unavailable
        </Text>
        <Text as="p" extraStyles="margin-bottom: 0">
          The payment method details for this transaction are unavailable.
        </Text>
      </Box>
    );
  }
};

export default ({ payment }) => {
  return (
    <Module heading="Payment Details" variant="small">
      <Box padding="24px">
        <PaymentDetailsContent payment={payment} />
      </Box>
    </Module>
  );
};
